import { MODAL_CONTENT_STRESS } from '@/parcours/flows/stress/modalContentStress';

export const symptomsStressConfig = {
  'Maladies cardiovasculaires': {
    title: 'Maladies cardiovasculaires',
    description:
      "Les maladies cardiovasculaires regroupent les pathologies qui touchent le cœur et l'ensemble des vaisseaux sanguins.",
    items: [
      {
        label: 'Avez-vous ressenti des palpitations ?',
        key: 'palpitations',
        type: 'scale_0_4',
      },
      {
        label: 'Avez-vous ressenti des douleurs au niveau du cœur ?',
        key: 'heart_pain',
        type: 'scale_0_4',
      },
    ],
    actions: [
      {
        label: 'Exercice de cohérence cardiaque',
        onClick: async ({ modal }) => {
          await modal.openModal({
            title: 'Exercice de cohérence cardiaque',
            content: MODAL_CONTENT_STRESS.MCV,
          });
        },
      },
    ],
  },

  Angoisse: {
    title: 'Angoisse',
    description:
      "Sentiment pénible d'alerte psychique et de mobilisation somatique devant une menace ou un danger indéterminés.",
    items: [
      {
        label: "Avez-vous ressenti des sueurs, en l'absence d'effort physique ?",
        key: 'sweat',
        type: 'scale_0_4',
      },
      {
        label: 'Avez-vous ressenti de la nervosité ou des tremblements ?',
        key: 'shaking',
        type: 'scale_0_4',
      },
      {
        label: 'Avez-vous ressenti des étourdissements ou vertiges ?',
        key: 'dizziness',
        type: 'scale_0_4',
      },
    ],
    actions: [
      {
        label: 'Activité sportive',
        onClick: async ({ modal }) => {
          await modal.openModal({
            title: 'Activité sportive',
            content: MODAL_CONTENT_STRESS.PHYSICAL_ACTIVITY_RECO,
          });
        },
      },
      {
        label: 'Automassage',
        onClick: async ({ modal }) => {
          await modal.openModal({
            title: 'Automassage',
            content: MODAL_CONTENT_STRESS.SELF_MASSAGE,
          });
        },
      },
      {
        label: 'Exercice de méditation',
        onClick: async ({ modal }) => {
          await modal.openModal({
            title: 'Exercice de méditation',
            content: MODAL_CONTENT_STRESS.GROUNDING_EXERCISE,
          });
        },
      },
    ],
  },

  'Problèmes gastro-intestinaux': {
    title: 'Problèmes gastro-intestinaux',
    description:
      'Les problèmes gastro-intestinaux dus au stress sont caractérisés par une douleur et un inconfort chronique centré sur la région de l’estomac. Ils se traduisent par une impression de « mal digérer ».',
    items: [
      {
        label: 'Avez-vous ressenti votre bouche sèche ?',
        key: 'dry_mouth',
        type: 'scale_0_4',
      },
      {
        label: "Avez-vous ressenti des brûlures d'estomac ?",
        key: 'stomach_ache',
        type: 'scale_0_4',
      },
      {
        label: 'Avez-vous ressenti des ballonnements, gaz ?',
        key: 'gas',
        type: 'scale_0_4',
      },
      {
        label: 'Avez-vous ressenti une digestion difficile ?',
        key: 'digestion',
        type: 'scale_0_4',
      },
      {
        label: 'Avez-vous ressenti des constipations ou des diarrhées ?',
        key: 'diarrhea',
        type: 'scale_0_4',
      },
    ],
    actions: [
      {
        label: 'Les réflexes au quotidien',
        onClick: async ({ modal }) => {
          await modal.openModal({
            title: 'Les réflexes au quotidien',
            content: MODAL_CONTENT_STRESS.EATING_HABITS,
          });
        },
      },
      {
        label: 'Automassage',
        onClick: async ({ modal }) => {
          await modal.openModal({
            title: 'Automassage',
            content: MODAL_CONTENT_STRESS.SELF_MASSAGE,
          });
        },
      },
    ],
  },

  Anxiété: {
    title: 'Anxiété',
    description:
      'L’anxiété est une émotion souvent ressentie comme désagréable qui correspond à l’attente plus ou moins consciente d’un danger ou d’un problème à venir.',
    items: [
      {
        label: "Avez-vous ressenti des sensations d'avoir l'estomac noué ?",
        key: 'stomach_ache',
        type: 'scale_0_4',
      },
      {
        label: 'Avez-vous ressenti des sensations de tension, de crispation ?',
        key: 'tension',
        type: 'scale_0_4',
      },
      {
        label: "Avez-vous ressenti de l'anxiété ?",
        key: 'anxiety',
        type: 'scale_0_4',
      },
      {
        label: "Avez-vous ressenti de l'irritabilité ?",
        key: 'irritability',
        type: 'scale_0_4',
      },
      {
        label: 'Avez-vous ressenti des états dépressifs ?',
        key: 'depression',
        type: 'scale_0_4',
      },
    ],
    actions: [
      {
        label: 'Activité sportive',
        onClick: async ({ modal }) => {
          await modal.openModal({
            title: 'Activité sportive',
            content: MODAL_CONTENT_STRESS.PHYSICAL_ACTIVITY_RECO,
          });
        },
      },
      {
        label: 'Automassage',
        onClick: async ({ modal }) => {
          await modal.openModal({
            title: 'Automassage',
            content: MODAL_CONTENT_STRESS.SELF_MASSAGE,
          });
        },
      },
      {
        label: 'Exercice de méditation',
        onClick: async ({ modal }) => {
          await modal.openModal({
            title: 'Exercice de méditation',
            content: MODAL_CONTENT_STRESS.GROUNDING_EXERCISE,
          });
        },
      },
    ],
  },

  Insomnies: {
    title: 'Insomnies',
    description: "L'insomnie se définit comme le sentiment d'avoir mal dormi en raison",
    items: [
      {
        label: "Avez-vous ressenti des difficultés d'endormissement ?",
        key: 'falling_asleep',
        type: 'scale_0_4',
      },
      {
        label: 'Avez-vous ressenti des insomnies ?',
        key: 'insomnia',
        type: 'scale_0_4',
      },
      {
        label: "Avez-vous ressenti des périodes de fatigue intense ou d'épuisement ?",
        key: 'tired',
        type: 'scale_0_4',
      },
    ],
    actions: [
      {
        label: 'Les réflexes au quotidien',
        onClick: async ({ modal }) => {
          await modal.openModal({
            title: 'Les réflexes au quotidien',
            content: MODAL_CONTENT_STRESS.SLEEP_HYGIENE,
          });
        },
      },
      {
        label: 'Exercice de respiration',
        onClick: async ({ modal }) => {
          await modal.openModal({
            title: 'Exercice de respiration',
            content: MODAL_CONTENT_STRESS.BREATHING_478,
          });
        },
      },
    ],
  },
};
